import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { resetPasswordActions } from './useResetPasswordStore.actions';
import { initialState } from './useResetPasswordStore.state';
import { ResetPasswordStore } from './useResetPasswordStore.types';

/**
 * Creates and configures the ResetPasswordStore.
 */
export const useResetPasswordStore = create(
  persist(
    immer<ResetPasswordStore>((set) => ({
      ...initialState,
      ...resetPasswordActions(set),
    })),
    {
      name: 'store-reset-password',
    }
  )
);
